import React from 'react';
import Logo from './kml.png'

function Footer(){
    return(
        <>
        <footer className='footer'>
         <div className='footerdiv'>
                <h4 style={{marginRight:'10px'}}>created by  </h4>
                    < a href='https://www.instagram.com/kamal_soni_____/' target='_blank' rel="noreferrer"
                    style={{    marginTop: 'auto'}}>
                <img src={Logo} height='30px' width='30px' /></a>
         </div>
        </footer>
           
        </>
    )
}
export default Footer;